import styled from 'styled-components';

export const StyledMessagePage = styled.div`
  .message-main {
    display: flex;
    flex-direction: row;
    height: 750px;
    border-top: 1px solid #e8e8e8;
    margin-top: 16px;
  }

  .left-main {
    width: 28%;
    min-width: 260px;
    border-right: 1px solid #e8e8e8;
    display: flex;
    flex-direction: column;
  }

  .right-main {
    width: 72%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .search-group {
    padding: 12px;
    border-bottom: 1px solid #e8e8e8;

    .search-input {
      width: 100%;
    }
  }

  .message-wrapper {
    height: 700px;
    overflow-y: auto;
  }

  .item-message {
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    position: relative;
    transition: background-color 0.2s;

    &:hover {
      background-color: #fafafa;
    }

    &.active {
      background-color: #f5f5f5;
    }
  }

  .item-message-preview-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }

  .un-read-row {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 4px;
  }

  .un-read-badge {
    min-width: 20px;
    height: 20px;
    border-radius: 10px;
    background-color: #ea5455;
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
    flex-shrink: 0;
    line-height: 1;
  }

  .un-read-text {
    font-size: 12px;
    color: #888;
  }

  .item-message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
  }

  .item-message-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }

  .un-read-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.palette.primary.main};
    flex-shrink: 0;
  }

  .item-message-author {
    font-weight: 600;
    font-size: 13px;
    color: #333;
  }

  .item-message-name {
    font-weight: 500;
    color: #444;
  }

  .item-message-more {
    color: ${({ theme }) => theme.palette.primary.main};
    font-weight: 400;
  }

  .item-message-date {
    font-size: 12px;
    color: #999;
  }

  .item-message-subject {
    font-size: 13px;
    color: #555;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 4px;
  }

  .item-message-assigned {
    font-size: 12px;
    color: #888;
  }

  .priority-badge {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 3px;
    font-size: 11px;
    font-weight: 500;
    color: #fff;

    &.high {
      background-color: #28c76f;
    }
    &.medium {
      background-color: #7367f0;
    }
    &.low {
      background-color: #ea5455;
    }
  }

  .load-more-btn {
    text-align: center;
    padding: 12px;
  }

  /* ==================== Chat View ==================== */

  .chat-view {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
  }

  .chat-detail-card {
    padding: 16px 24px;
    border-bottom: 1px solid #e8e8e8;
    background: #fff;

    .chat-detail-row {
      display: flex;
      align-items: flex-start;
      padding: 4px 0;
    }

    .chat-detail-label {
      width: 140px;
      flex-shrink: 0;
      font-size: 13px;
      color: #888;
    }

    .chat-detail-value {
      flex: 1;
      font-size: 14px;
      font-weight: 500;
      color: #333;
      line-height: 1.5;
    }

    .chat-detail-toggle {
      color: ${({ theme }) => theme.palette.primary.main};
      cursor: pointer;
      font-size: 13px;
      font-weight: 400;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .chat-messages {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .chat-bubble-wrapper {
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
  }

  .chat-bubble-wrapper-left {
    align-items: flex-start;
  }

  .chat-bubble-wrapper-right {
    align-items: flex-end;
  }

  .chat-bubble-info {
    font-size: 11px;
    color: #999;
    margin-bottom: 2px;
    display: flex;
    gap: 6px;
    align-items: center;
  }

  .chat-bubble-sender {
    font-weight: 600;
    color: #555;
    font-size: 12px;
  }

  .chat-bubble {
    max-width: 70%;
    padding: 10px 14px;
    border-radius: 12px;
    font-size: 13px;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
    position: relative;
  }

  .chat-bubble-left {
    background-color: ${({ theme }) => theme.palette.neutral[100]};
    border-top-left-radius: 4px;
  }

  .chat-bubble-right {
    background-color: ${({ theme }) => theme.palette.primary[75]};
    border-top-right-radius: 4px;
  }

  .chat-bubble-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 4px;
    margin-top: 4px;
  }

  .chat-bubble-time-inline {
    font-size: 10px;
    color: #999;
  }

  .chat-bubble-ticks {
    display: inline-flex;
    align-items: center;
    line-height: 1;
  }

  .chat-input-bar {
    display: flex;
    align-items: center;
    padding: 10px 16px 10px 20px;
    border: 1.5px solid ${({ theme }) => theme.palette.primary.main};
    border-radius: 10px;
    margin: 0 16px 16px;
    flex-shrink: 0;
    background: #fff;
    box-shadow: none;

    .chat-input {
      flex: 1;

      .ant-input,
      textarea.ant-input {
        border: none;
        box-shadow: none !important;
        padding: 4px 0;
        resize: none;
        font-size: 14px;
        background: transparent;
        line-height: 1.5;

        &::placeholder {
          color: ${({ theme }) => theme.palette.primary[500]};
          font-size: 14px;
          font-weight: 500;
        }

        &:focus {
          box-shadow: none !important;
        }
      }
    }

    .chat-send-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      border: none;
      border-radius: 50%;
      background: transparent;
      cursor: pointer;
      flex-shrink: 0;
      padding: 0;
      color: #fff;
      background: ${({ theme }) => theme.palette.primary.main};
      transition: color 0.2s, background-color 0.2s, transform 0.15s;

      &:hover {
        background: ${({ theme }) => theme.palette.primary[700]};
        transform: scale(1.05);
      }

      &:active {
        transform: scale(0.95);
      }

      &:disabled {
        color: #fff;
        background: ${({ theme }) => theme.palette.primary.main};
        cursor: not-allowed;
        transform: none;
        opacity: 1;
      }

      svg {
        display: block;
      }
    }
  }

  /* ==================== Form Create ==================== */

  .form-create {
    padding: 16px;
    overflow-y: auto;
    flex: 1;

    .form-row {
      margin-bottom: 16px;

      .form-label {
        font-weight: 600;
        margin-bottom: 6px;
        display: block;
        color: #555;
      }
    }
  }

  /* ==================== Header Actions ==================== */

  .message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
  }

  .message-filters {
    display: flex;
    gap: 12px;
    align-items: center;

    .filter-select {
      min-width: 160px;
    }
  }

  .message-actions {
    display: flex;
    gap: 8px;
  }

  .empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 48px 24px;
    color: #999;
    font-size: 14px;
  }
`;
